// extracted by mini-css-extract-plugin
export default {"loadingText":"ApplyCouponView_loadingText__0IzMt"};